import React, { useContext, useState } from "react";
import "./ReceivedInvitationsModal.css";
import { IoCloseOutline } from "react-icons/io5";
import { useLanguage } from "../../LanguageProvider";
import { GeneralContext } from "../../GeneralProvider";
import CollaboratorsTable from "../../pages/CollaboratorsPage/components/CollaboratorsTable/CollaboratorsTable";


export default function ReceivedInvitationsModal({ isOpen, onClose }) {
    const { getTranslation } = useLanguage();
    const {
        receivedInvitations,
        handleAcceptInvitation,
        handleRejectInvitation,

        receivedProjectInvitations,
        handleAcceptProjectInvitation,
        handleRejectProjectInvitation,
    } = useContext(GeneralContext);

    if (!isOpen) return null;

    const receivedInvitationsDataFieldMapping = {
        [getTranslation("name") + " " + getTranslation("lastname")]: "nameLastname",
        [getTranslation("email")]: "email",
        [getTranslation("expirationDate")]: "expirationDate",
        [getTranslation("actions")]: "status",
    };

    const receivedInvitationsHeaders = [
        getTranslation("name") + " " + getTranslation("lastname"),
        getTranslation("email"),
        getTranslation("expirationDate"),
        getTranslation("actions"),
    ];

    const receivedInvitationsData = receivedInvitations?.map((invitation) => ({
        nameLastname: `${invitation.inviterName} ${invitation.inviterLastname}`,
        email: invitation.inviterEmail,
        expirationDate: invitation.expiredDateTime
            ? new Date(invitation.expiredDateTime * 1000).toLocaleDateString()
            : "No Expiry",
        status: (
            <div className="collaborators-table-status-holder">
                <button
                    onClick={() => handleAcceptInvitation(invitation.invitationCode)}
                    className="collaborators-table-accept-button"
                >
                    {getTranslation("accept")}
                </button>
                <button
                    onClick={() => handleRejectInvitation(invitation.invitationCode)}
                    className="collaborators-table-reject-button"
                >
                    {getTranslation("reject")}
                </button>
            </div>
        ),
    }));

    const receivedProjectInvitationsHeaders = [
        getTranslation("name") + " " + getTranslation("lastname"),
        getTranslation("email"),
        getTranslation("projectTitle"),
        getTranslation("actions"),
    ];

    const receivedProjectInvitationsData = receivedProjectInvitations?.map((invitation) => ({
        nameLastname: `${invitation.name} ${invitation.lastname}`,
        email: invitation.email,
        projectTitle: invitation.projectTitle,
        actions: (
            <div className="collaborators-table-status-holder">
                <button
                    onClick={() => handleAcceptProjectInvitation(invitation.authID)}
                    className="collaborators-table-accept-button"
                >
                    {getTranslation("accept")}
                </button>
                <button
                    onClick={() => handleRejectProjectInvitation(invitation.authID)}
                    className="collaborators-table-reject-button"
                >
                    {getTranslation("reject")}
                </button>
            </div>
        ),
    }));

    const receivedProjectInvitationsDataFieldMapping = {
        [getTranslation("name") + " " + getTranslation("lastname")]: "nameLastname",
        [getTranslation("email")]: "email",
        [getTranslation("projectTitle")]: "projectTitle",
        [getTranslation("actions")]: "actions",
    };

    return (
        <div className="received-invitations-modal-overlay">
            <div className="received-invitations-modal-container">
                <IoCloseOutline
                    className="received-invitations-modal-button close"
                    onClick={onClose}
                />

                <span className="received-invitations-modal-title">{getTranslation("inviteList")}</span>

                <span className="collaborators-title">
                    {receivedInvitations.length + receivedProjectInvitations.length === 0 && getTranslation('noInvitations')}
                </span>

                {receivedInvitations.length > 0 &&
                    <>
                        <span className="collaborators-title">
                            {getTranslation("collaborators")}
                        </span>
                        <CollaboratorsTable
                            headers={receivedInvitationsHeaders}
                            data={receivedInvitationsData}
                            fieldMapping={receivedInvitationsDataFieldMapping}
                        />
                    </>
                }

                {receivedInvitations.length === 0 && receivedProjectInvitations.length > 0 &&
                    <span className="collaborators-title">
                        {getTranslation("noCollaboratorInvitations")}
                    </span>
                }

                {receivedProjectInvitations.length > 0 &&
                    <>
                        <span className="collaborators-title">
                            {getTranslation("projects")}
                        </span>
                        <CollaboratorsTable
                            headers={receivedProjectInvitationsHeaders}
                            data={receivedProjectInvitationsData}
                            fieldMapping={receivedProjectInvitationsDataFieldMapping}
                        />
                    </>
                }

                {receivedInvitations.length > 0 && receivedProjectInvitations.length === 0 &&
                    <span className="collaborators-title">
                        {getTranslation("noProjectInvitations")}
                    </span>
                }

            </div>
        </div>
    );
}
